import script from "./RuleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleCard.vue?vue&type=script&setup=true&lang=js"

import "./RuleCard.vue?vue&type=style&index=0&id=35b56768&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b56768"]])

export default __exports__